<template>
	<section v-if="items.length" class="promotions align-center">
		<slot name="blocks-header" />
		<div class="row">
			<div v-for="block in items.slice(0, amount)" :key="block.ID" class="columns column4">
				<div class="promotion">
					<div class="image">
						<nuxt-link :to="block.link">
							<picture>
								<source :srcset="block.imageWebp" type="image/webp" />
								<source :srcset="block.image" />
								<img :src="block.image" :alt="block.imageAlt" loading="lazy" />
							</picture>
						</nuxt-link>
					</div>
					<div class="content">
						<h4>
							<nuxt-link :to="block.link">
								{{ block.header }}
							</nuxt-link>
						</h4>
						<div v-parse-links v-html="block.content" />
						<nuxt-link :to="block.link" class="button" target="_self">
							{{ $t('readMore') }}
						</nuxt-link>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
});
</script>

<style lang="scss" scoped>
.row {
	justify-content: center;
}

.promotions {
	background: url('~/assets/images/promoblocks-bg-pattern.png') no-repeat center top 50px #fff;
	background-size: 100%;

	.columns {
		display: flex;
	}
}

.promotion {
	margin: 0 auto 20px;
	position: relative;
	overflow: hidden;
	width: 100%;

	.content {
		background: var(--secondary-background-color);
		z-index: 3;
		padding: 40px 25px 60px;
		color: var(--body-color);
		position: relative;

		h4 a {
			text-decoration: none;
			color: var(--header-color);
		}

		.button {
			position: absolute;
			bottom: 0;
			right: 0;
		}
	}

	.image {
		display: block;
		overflow: hidden;
		position: relative;

		img {
			transition: all 0.3s ease-in-out;
			background: #000;
			opacity: 0.92;
			z-index: 1;
			position: relative;
			width: 100%;
			height: 100%;
			object-fit: cover;
			min-height: 400px;
			display: block;
		}

		&:hover img {
			opacity: 1;
		}
	}
}
</style>
